import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../../css/Auth/otp.css";
import LogoBottom from "../../assets/images/shreepuram_vijay_prateek.png";
import {
  saveAccessToken,
  saveRefreshToken,
  saveUserId,
  setUserRole,
  setkycStatus,
  setUserProfile,
  setUserFullName,
} from "../../utils/auth";
import LogoCards from "../../components/ui/Cards/LogoCards";
import Button from "../../components/ui/Button/Button";
import { FaArrowRightToBracket } from "react-icons/fa6";
import api from "../../api/axios";
import { toast } from "react-toastify";
const OTP_EXPIRY_SECONDS = 60;
const OTP_TIME_KEY = "otp_sent_time";

const OTP = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const phone = location.state?.phone;
  const formData = location.state?.formData;
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [timer, setTimer] = useState(0);
  const [resendDisabled, setResendDisabled] = useState(true);
  const [loading, setLoading] = useState(false);

  const logos = [
    "/images/logo6.png",
    "/images/logo7.png",
    "/images/logo5.png",
    "/images/logo4.png",
    "/images/logo3.png",
  ];

  // TIMER FROM localStorage
  useEffect(() => {
    const sentTime = localStorage.getItem(OTP_TIME_KEY);

    if (!sentTime) {
      setResendDisabled(false);
      return;
    }

    const elapsed = Math.floor((Date.now() - Number(sentTime)) / 1000);
    const remaining = OTP_EXPIRY_SECONDS - elapsed;

    if (remaining > 0) {
      setTimer(remaining);
      setResendDisabled(true);
    } else {
      setTimer(0);
      setResendDisabled(false);
    }
  }, []);

  // Countdown timer
  // useEffect(() => {
  //   if (timer > 0) {
  //     const interval = setInterval(() => setTimer(prev => prev - 1), 1000);
  //     return () => clearInterval(interval);
  //   } else {
  //     setResendDisabled(false);
  //   }
  // }, [timer]);

  ///////////////////////////////////////
  useEffect(() => {
    if (timer <= 0) return;

    const interval = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          setResendDisabled(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [timer]);
  ///////////////////////////////////////

  // Handle OTP input change
  const handleChange = (e, index) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Move focus to next input
      if (value && index < otp.length - 1) {
        document.getElementById(`otp-${index + 1}`).focus();
      }
    }
  };

  // Handle Backspace
  const handleBackspace = (e, index) => {
    if (e.key === "Backspace" && otp[index] === "" && index > 0) {
      document.getElementById(`otp-${index - 1}`).focus();
    }
  };

  // Handle Paste
  const handlePaste = (e) => {
    e.preventDefault();
    const pastedOtp = e.clipboardData.getData("Text").slice(0, 6);
    const newOtp = pastedOtp
      .split("")
      .map((digit, i) => (i < otp.length ? digit : ""));
    setOtp(newOtp);
    const lastFilled = newOtp.filter((d) => d !== "").length - 1;
    if (lastFilled >= 0) {
      document.getElementById(`otp-${lastFilled}`).focus();
    }
  };

  // Verify OTP API
  const handleVerify = async () => {
    const enteredOtp = otp.join("");
    if (enteredOtp.length !== 6) {
      toast.error("Enter 6-digit OTP");
      return;
    }

    setLoading(true);
    try {
      const response = await api.post(
        "/auth/verify-otp",
        { phone, otp: enteredOtp },
        { headers: { "Content-Type": "application/json" } },
      );
      if (response.data.verified) {
        localStorage.removeItem(OTP_TIME_KEY);
        const register = await api.post("/auth/register", {
          ...formData,
        });

        // if (register.data.message === "Registered successfully") {
        //   saveToken(register.data.token);
        //   saveUserId(register.data.userId);
        //   setUserFullName(response.data?.fullName);
        //   setUserRole(response.data?.role);

        //   console.log(
        //     register.data.token,
        //     register.data.userId,
        //     response.data.fullName,
        //     response.data.role,
        //   );

        //   navigate("/feed/prime");
        // }
        if (register.data.message === "Registered successfully") {
  const { accessToken, refreshToken, user } = register.data;

  // ✅ Save tokens
  saveAccessToken(accessToken);
  saveRefreshToken(refreshToken);

  // ✅ Save user data
  saveUserId(user.userId);
  setUserFullName(user.fullName);
  setUserRole(user.role);
  setkycStatus(user.kycStatus);
  setUserProfile(user.profilePic);

  navigate("/feed/prime");
}
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  // Resend OTP API

  ////////////////////////////////
  const handleResend = async () => {
    if (resendDisabled) return;

    setLoading(true);
    try {
      await api.post("/auth/send-otp", { phone });

      localStorage.setItem(OTP_TIME_KEY, Date.now().toString()); // Store current time

      setOtp(["", "", "", "", "", ""]);
      setTimer(OTP_EXPIRY_SECONDS);
      setResendDisabled(true);

      toast.success("OTP Resent Successfully")
    } catch (err) {
      console.error(err);
      toast.error(
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        "Failed to resend OTP",
      );
    } finally {
      setLoading(false);
    }
  };
  ////////////////////////////////

  return (
    <div className="otp-wrapper">
      <div className="col-6 otp-left01">
        <div className="otp-content01">
          <h2>
            Welcome To{" "}
            <span className="second-line02">
              Bharat Jagriti{" "}
              <span id="tm">
                <sup>™ </sup>
              </span>
            </span>
          </h2>
          <p className="tagline01">EXPLORE THE TRUTH TO THE WORLD</p>
          <LogoCards />
        </div>
      </div>

      {/* RIGHT */}

      <div className="otp-right">
        <div className="right-content">
          <h2 className="right-title">Check Your Phone</h2>
          <p className="right-sub">
            We've sent the code to your phone: <b>{phone}</b>
          </p>

          <div className="otp-box-row px-md-0 px-2">
            {otp.map((digit, index) => (
              <input
                key={index}
                id={`otp-${index}`}
                type="text"
                maxLength="1"
                className="otp-box"
                value={digit}
                onChange={(e) => handleChange(e, index)}
                onKeyDown={(e) => handleBackspace(e, index)}
                onPaste={handlePaste}
              />
            ))}
          </div>

          <p className="expire-text">
            Code expires in{" "}
            <span>
              {`${Math.floor(timer / 60)
                .toString()
                .padStart(2, "0")}:${(timer % 60).toString().padStart(2, "0")}`}
            </span>
            &nbsp;
            <span
              className="resend"
              onClick={handleResend}
              style={{
                color: resendDisabled ? "grey" : "blue",
                cursor: resendDisabled ? "not-allowed" : "pointer",
              }}
            >
              Resend
            </span>
          </p>

          <Button
            className={"NextBtn"}
            style={{
              width: "50%",
              margin: "auto",
              padding: "8px 10px",
              borderRadius: "20px",
              backgroundColor: "var(--color1)",
              display: "flex",
              alignItem: "center",
              justifyContent: "center",
              color: "white",
              fontWeight: "bold",
              gap: "10px",
            }}
            onClick={handleVerify}
            icon={FaArrowRightToBracket}
            disabled={loading}
          >
            {loading ? "Loading..." : "Verify"}
          </Button>
        </div>

        <div className="OTP_bottom_logo">
          <img src={LogoBottom} alt="powered" />
          <p>Powered by Sripuram</p>
        </div>

      </div>
    </div>
  );
};

export { OTP };
